var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSerbia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C7.1635 0.0107422 0 7.17424 0 16.0107C0 17.9679 0.352063 19.8427 0.995188 21.5759H31.0049C31.648 19.8427 32 17.9679 32 16.0107C32 7.17424 24.8365 0.0107422 16 0.0107422Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C9.12055 0.0107422 3.25587 4.35274 0.995178 10.4456H31.0049C28.7441 4.35274 22.8794 0.0107422 16 0.0107422Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13776 9.0542V17.0358C4.13776 21.5761 10.0691 22.9673 10.0691 22.9673C10.0691 22.9673 16.0003 21.5761 16.0003 17.0358V9.0542H4.13776Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59039 10.4457H13.547V7.66304L12.1556 8.35867L10.0687 6.27173L7.98171 8.35867L6.59039 7.66304V10.4457Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 18.1472L10.0869 13.6255L5.56519 18.1472L7.04087 19.6229L10.0869 16.5769L13.133 19.6229L14.6087 18.1472Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6087 13.9237H12.4989C12.6176 13.719 12.6866 13.4819 12.6866 13.2282C12.6866 12.4597 12.0636 11.8369 11.2952 11.8369C10.7643 11.8369 10.3032 12.1343 10.0687 12.5715C9.83412 12.1344 9.37306 11.8369 8.84212 11.8369C8.07375 11.8369 7.45081 12.4597 7.45081 13.2282C7.45081 13.4819 7.51981 13.719 7.63844 13.9237H5.56519C5.56519 14.6922 6.2345 15.315 7.00281 15.315H6.9565C6.9565 16.0835 7.57937 16.7064 8.34781 16.7064C8.34781 17.3867 8.83644 17.952 9.48175 18.073L8.3855 20.5481C8.91087 20.7617 9.485 20.8803 10.087 20.8803C10.689 20.8803 11.2631 20.7617 11.7885 20.5481L10.6922 18.073C11.3376 17.9521 11.8262 17.3868 11.8262 16.7064C12.5946 16.7064 13.2175 16.0835 13.2175 15.315H13.1712C13.9394 15.315 14.6087 14.6921 14.6087 13.9237Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSerbia);
export default __webpack_public_path__ + "static/media/flag_serbia.300789d620a84ba24d1523bdfd530761.svg";
export { ForwardRef as ReactComponent };